import type { ReactNode } from "react";

import { icons } from "~/ui";

interface EmptyCsvStateProps {
  label?: ReactNode;
}

export const EmptyCsvState = ({ label }: EmptyCsvStateProps = {}) => (
  <div className="absolute flex flex-col items-center justify-center gap-2">
    <icons.outline.DocumentTextIcon className="size-5 text-neutral-500" />
    <span className="text-center text-neutral-500">
      {label ?? (
        <>
          Drag and drop or{" "}
          <span className="text-violet font-medium">click to browse</span>
        </>
      )}
    </span>
  </div>
);
